import React from 'react';
import { ImageBackground } from 'react-native';
import { DNABox, DNAText, Iffy } from '@alucio/lux-ui';
function ShareContent(props) {
    return (React.createElement(DNABox, { fill: true },
        React.createElement(ImageBackground, { testID: "content-share-bg", source: props.background, style: { flex: 1, backgroundColor: 'black' }, imageStyle: { opacity: 0.5 } },
            React.createElement(Iffy, { is: props.showWelcomeText },
                React.createElement(DNABox, { fill: true, alignX: "center", alignY: "center" },
                    React.createElement(DNAText, { testID: "content-share-text", h1: true, status: "basic" }, props.text))))));
}
export default ShareContent;
//# sourceMappingURL=ShareContent.js.map